import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5PortfoliosEdit } from "./edit";
import { A5PortfoliosNew } from "./new";
import { A5PortfoliosTable } from "./table";
export default function A5Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portfolios");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5PortfoliosEdit />} />
      <Route index element={<A5PortfoliosTable />} />
      <Route path="/new" element={<A5PortfoliosNew />} />
    </Routes>
  );
}
